import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RequestCancelService {
  private cancelAll$ = new Subject<void>();

  cancelSignal$ = this.cancelAll$.asObservable();

  cancelAllRequests() {
    this.cancelAll$.next();
  }
}
